var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIconYoutubefe3D66A05F96F7Ff73596Ebca3D9D59C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 28727",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.536,
    height: 29.536,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.319 16.592l3.8-1.97-3.8-1.985z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 80",
    d: "M14.768 0a14.768 14.768 0 1014.768 14.768A14.768 14.768 0 0014.768 0zm7.089 15.3a21.5 21.5 0 01-.141 2.295 3.071 3.071 0 01-.564 1.407 2.025 2.025 0 01-1.421.6c-1.984.143-4.963.148-4.963.148s-3.686-.034-4.82-.143a2.4 2.4 0 01-1.564-.605 3.071 3.071 0 01-.563-1.407 21.333 21.333 0 01-.142-2.295v-1.075a21.332 21.332 0 01.142-2.295 3.07 3.07 0 01.563-1.407 2.026 2.026 0 011.421-.6c1.984-.144 4.96-.144 4.96-.144h.007s2.975 0 4.959.144a2.025 2.025 0 011.421.6 3.071 3.071 0 01.564 1.407 21.5 21.5 0 01.141 2.295z",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconYoutubefe3D66A05F96F7Ff73596Ebca3D9D59C);
export default __webpack_public_path__ + "static/media/social-icon-youtube.fe3d66a05f96f7ff73596ebca3d9d59c.1e6aef5444eb7cb2c1cea2fcdd350a23.svg";
export { ForwardRef as ReactComponent };